import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'lib-progress-bar',
    template: `
    @if (progress) {
      <div class="progress-container">
        <div class="progress-text">
          Postęp: {{ progress.completed }} / {{ progress.total }} ({{ progress.percentage }}%)
        </div>
        <svg class="progress-bar" width="100%" height="10" viewBox="0 0 100 10" preserveAspectRatio="none">
          <rect class="progress-bar-bg" x="0" y="0" width="100" height="10" rx="5" />
          <rect class="progress-bar-fill" x="0" y="0" [attr.width]="progress.percentage" height="10" rx="5" />
        </svg>
      </div>
    }
    `,
    styles: [`
    .progress-container {
      margin-bottom: 15px;
    }

    .progress-text {
      font-size: 14px;
      margin-bottom: 5px;
      font-weight: bold;
    }

    .progress-bar {
      width: 100%;
    }

    .progress-bar-bg {
      fill: #e0e0e0;
    }

    .progress-bar-fill {
      fill: #0c4da2;
      transition: width 0.3s ease;
    }
  `],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProgressBarComponent {
  @Input() progress: { completed: number; total: number; percentage: number };
}
